import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useMutation from 'hooks/useMutation';
import MutationKeys from 'hooks/mutations/keys';
import QueryKeys from 'hooks/queries/keys';
import type { UpdateRoleInput, UpdateRoleApiResponse } from 'domains/accessCentre/types';

const useUpdateRole = (
    roleId: number,
    mutateOptions?: UseMutationOptions<UpdateRoleApiResponse, Error, UpdateRoleInput>
) => {
    const queryClient = useQueryClient();
    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<UpdateRoleInput, UpdateRoleApiResponse>(
        MutationKeys.UPDATE_ROLE(roleId),
        new PathWithID(CuredApiPaths.ACCESS_CENTRE_ROLES, roleId),
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(['access-centre', 'roles']);
                queryClient.invalidateQueries(QueryKeys.ACCESS_CENTRE_ROLE_ID(roleId));
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.PUT
    );
};

export default useUpdateRole;
